import { GridSkeleton, TextSkeleton } from "@/components/Skeletons";

export default function StrategicGuideSkeleton() {
  return (
    <div className="pb-16">
      <div className="flex gap-4">
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={5} />
          <GridSkeleton columns={4} rows={2} />
        </div>
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={5} />
          <GridSkeleton columns={4} rows={2} />
        </div>
      </div>
      <div className="py-4" />
      <div className="py-4" />

      <div className="flex gap-4">
        <div className="flex w-1/2 flex-col gap-4">
          <TextSkeleton width={5} />
          <GridSkeleton columns={2} rows={2} />
        </div>
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={5} />
          <GridSkeleton columns={2} rows={2} />
        </div>
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={5} />
          <GridSkeleton columns={2} rows={2} />
        </div>
      </div>

      <div className="py-4" />
      <div className="py-4" />

      <div className="flex flex-col gap-4">
        <TextSkeleton width={5} />
        <GridSkeleton columns={2} rows={4} />
      </div>

      <div className="py-4" />
      <div className="py-4" />

      <div className="flex gap-4">
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={5} />
          <GridSkeleton columns={2} rows={4} />
        </div>
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={5} />
          <GridSkeleton columns={2} rows={4} />
        </div>
      </div>

      <div className="py-4" />
      <div className="py-4" />

      <div className="flex w-1/2 gap-6">
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={10} />
          <GridSkeleton columns={3} rows={2} />
        </div>
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={10} />
          <GridSkeleton columns={3} rows={2} />
        </div>
      </div>
    </div>
  );
}
